import React from "react";

// ธีมป้ายตำแหน่ง: แต่ละตำแหน่งมีสี ไอคอน และเอฟเฟกต์เฉพาะตัว
// tier ใช้คุมระดับความ "พรีเมี่ยม" ของเอฟเฟกต์ (exec = เรืองแสง + ไล่แสงวิ่ง, lead/staff = ไล่แสงเบา ๆ)
export const positionThemes = {
  CEO: {
    label: "CEO",
    icon: "fa-crown",
    tier: "exec",
    bg: "linear-gradient(135deg, #fffaea 0%, #ffeec4 45%, #f7dda0 100%)",
    border: "rgba(184, 138, 32, 0.42)",
    color: "#8a6212",
    glow: "rgba(212, 165, 55, 0.45)",
    delay: "0s",
  },
  CTO: {
    label: "CTO",
    icon: "fa-microchip",
    tier: "exec",
    bg: "linear-gradient(135deg, #f2f1ff 0%, #e3e2ff 45%, #d2d3fb 100%)",
    border: "rgba(96, 92, 199, 0.38)",
    color: "#4a45ad",
    glow: "rgba(112, 106, 224, 0.40)",
    delay: "0.6s",
  },
  CFO: {
    label: "CFO",
    icon: "fa-chart-line",
    tier: "exec",
    bg: "linear-gradient(135deg, #eefbf4 0%, #dbf5e8 45%, #c6eeda 100%)",
    border: "rgba(28, 141, 98, 0.36)",
    color: "#137a52",
    glow: "rgba(40, 168, 116, 0.38)",
    delay: "1.2s",
  },
  MANAGER: {
    label: "Manager",
    icon: "fa-user-tie",
    tier: "lead",
    bg: "linear-gradient(135deg, #eef6ff 0%, #dcebff 100%)",
    border: "rgba(12, 118, 229, 0.30)",
    color: "#0b5cb5",
    glow: "rgba(12, 118, 229, 0.28)",
    delay: "1.8s",
  },
  ADMIN: {
    label: "Admin",
    icon: "fa-shield-halved",
    tier: "lead",
    bg: "linear-gradient(135deg, #f3f6f9 0%, #e4eaf1 100%)",
    border: "rgba(84, 106, 128, 0.30)",
    color: "#4a6076",
    glow: "rgba(84, 106, 128, 0.24)",
    delay: "2.4s",
  },
  HR_OFFICER: {
    label: "HR Officer",
    icon: "fa-people-group",
    tier: "lead",
    bg: "linear-gradient(135deg, #fff1f6 0%, #ffdfeb 100%)",
    border: "rgba(198, 74, 122, 0.30)",
    color: "#b6497a",
    glow: "rgba(214, 92, 140, 0.28)",
    delay: "3s",
  },
  ACCOUNTANT: {
    label: "Accountant",
    icon: "fa-calculator",
    tier: "lead",
    bg: "linear-gradient(135deg, #fff7ec 0%, #ffe9cd 100%)",
    border: "rgba(184, 122, 26, 0.30)",
    color: "#a76a12",
    glow: "rgba(214, 148, 44, 0.28)",
    delay: "3.6s",
  },
  SOFTWARE_ENGINEER: {
    label: "Software Engineer",
    icon: "fa-code",
    tier: "staff",
    bg: "linear-gradient(135deg, #ecfbff 0%, #d5f1fb 100%)",
    border: "rgba(20, 132, 168, 0.30)",
    color: "#0e7191",
    glow: "rgba(28, 158, 199, 0.26)",
    delay: "4.2s",
  },
  CUSTOMER_SUPPORT: {
    label: "Customer Support",
    icon: "fa-headset",
    tier: "staff",
    bg: "linear-gradient(135deg, #f6f1ff 0%, #e8dfff 100%)",
    border: "rgba(124, 82, 196, 0.30)",
    color: "#6a45b0",
    glow: "rgba(139, 96, 214, 0.26)",
    delay: "4.8s",
  },
};

export const defaultPositionTheme = {
  label: "",
  icon: "fa-id-badge",
  tier: "staff",
  bg: "linear-gradient(135deg, #f5f8fb 0%, #e8eef4 100%)",
  border: "rgba(94, 118, 138, 0.26)",
  color: "#54708a",
  glow: "rgba(94, 118, 138, 0.20)",
  delay: "5.4s",
};

export const getPositionTheme = (position) =>
  positionThemes[position] || { ...defaultPositionTheme, label: position || "" };

// สไตล์ป้ายตำแหน่ง ฉีดเข้า <head> ครั้งเดียวต่อแอป (ใช้ร่วมได้ทุกหน้า)
const POSITION_BADGE_STYLE_ID = "ptn-position-badge-style";
const POSITION_BADGE_CSS = `
.ptn-pos {
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
  padding: 0.34rem 0.78rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  white-space: nowrap;
  background: var(--pos-bg);
  border: 1px solid var(--pos-border);
  color: var(--pos-color);
  box-shadow: 0 2px 6px rgba(11, 79, 132, 0.06);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.ptn-pos__icon { font-size: 0.74rem; opacity: 0.9; }
.ptn-pos__label { overflow: hidden; text-overflow: ellipsis; }
/* แถบแสงเฉียงวิ่งผ่านป้าย */
.ptn-pos::after {
  content: "";
  position: absolute;
  top: -60%;
  left: -140%;
  width: 60%;
  height: 220%;
  background: linear-gradient(100deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.75) 50%, rgba(255,255,255,0) 100%);
  transform: rotate(14deg);
  animation: ptnPosSheen 7s ease-in-out infinite;
  animation-delay: var(--pos-delay, 0s);
  pointer-events: none;
}
.ptn-pos:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px var(--pos-glow);
}
/* ระดับผู้บริหาร: เรืองแสงเป็นจังหวะ + แสงวิ่งถี่กว่า */
.ptn-pos--exec {
  animation: ptnPosGlow 3.4s ease-in-out infinite;
  animation-delay: var(--pos-delay, 0s);
}
.ptn-pos--exec::after { animation-duration: 4.6s; }
.ptn-pos--exec .ptn-pos__icon {
  animation: ptnPosIcon 3.4s ease-in-out infinite;
  animation-delay: var(--pos-delay, 0s);
}
.ptn-pos--lead::after { animation-duration: 6s; }
/* บนพื้นเข้ม (เช่น hero) ให้ป้ายดูเป็นแก้วฝ้าแทนพาสเทล */
.ptn-pos--on-dark {
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.34);
  color: #ffffff;
  backdrop-filter: blur(6px);
  box-shadow: 0 6px 18px rgba(4, 24, 44, 0.24);
}
@keyframes ptnPosSheen {
  0% { left: -140%; }
  28%, 100% { left: 160%; }
}
@keyframes ptnPosGlow {
  0%, 100% { box-shadow: 0 2px 8px var(--pos-glow); }
  50% { box-shadow: 0 6px 18px var(--pos-glow); }
}
@keyframes ptnPosIcon {
  0%, 100% { transform: scale(1); opacity: 0.9; }
  50% { transform: scale(1.14); opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .ptn-pos, .ptn-pos::after, .ptn-pos .ptn-pos__icon { animation: none !important; }
}
`;

if (typeof document !== "undefined" && !document.getElementById(POSITION_BADGE_STYLE_ID)) {
  const styleTag = document.createElement("style");
  styleTag.id = POSITION_BADGE_STYLE_ID;
  styleTag.innerHTML = POSITION_BADGE_CSS;
  document.head.appendChild(styleTag);
}

// ป้ายตำแหน่งพร้อมเอฟเฟกต์ — onDark = ใช้บนพื้นหลังเข้ม
export default function PositionBadge({ position, onDark = false, className = "" }) {
  if (!position) return <span className={onDark ? "opacity-75" : "text-secondary"}>-</span>;

  const theme = getPositionTheme(position);
  return (
    <span
      className={`ptn-pos ptn-pos--${theme.tier}${onDark ? " ptn-pos--on-dark" : ""}${className ? ` ${className}` : ""}`}
      title={theme.label || position}
      style={{
        "--pos-bg": theme.bg,
        "--pos-border": theme.border,
        "--pos-color": theme.color,
        "--pos-glow": theme.glow,
        "--pos-delay": theme.delay,
      }}
    >
      <i className={`fa-solid ${theme.icon} ptn-pos__icon`} />
      <span className="ptn-pos__label">{theme.label || position}</span>
    </span>
  );
}
